module.exports = __webpack_public_path__ + "static/media/left_QR_code.be0e3039.png";